module.exports = __webpack_public_path__ + "static/4-5364840dfc6aa2e68a5be51afded0405.png";